import React, { useEffect, useRef } from 'react';

function InstagramEmbedSimple({ url, maxWidth = 480 }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!window.instgrm) {
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.onload = () => window.instgrm.Embeds.process();
      document.body.appendChild(script);
    } else {
      window.instgrm.Embeds.process();
    }
  }, [url]);

  return (
    <blockquote
      ref={ref}
      className="instagram-media"
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{
        background: '#fff',
        border: 0,
        margin: 0,
        padding: 0,
        maxWidth: maxWidth,
        width: '100%',
        minWidth: 320,
      }}
    ></blockquote>
  );
}

export default InstagramEmbedSimple; 